import { get } from 'svelte/store';
import { format } from 'svelte-i18n';
//Helpers
import { isProAnyEM } from 'src/helpers/interface_helpers';
import { devices, devices_settings, user_settings } from 'src/stores';
import { compareFWVersions } from 'src/helpers/firmware_compare_helpers';
//Types
import type { Device } from 'src/types/Device';
import type { SelectOptionPropsType } from '@Shelly/shelly-design-system/index';
import { postReq } from 'src/services/http';

type netMeteringPeriodsSelectOptionsTypes = SelectOptionPropsType & {
	value: number;
};

export const getNetMeteringPeriods = (): netMeteringPeriodsSelectOptionsTypes[] => {
	const $format = get(format);
	return [
		{
			value: 0,
			title: $format('net_metering_period_0', { default: 'None' }),
		},
		{
			value: 5,
			title: $format('net_metering_period_5', { default: '5min' }),
		},
		{
			value: 15,
			title: $format('net_metering_period_15', { default: '15min' }),
		},
		{
			value: 30,
			title: $format('net_metering_period_30', { default: '30min' }),
		},
		{
			value: 60,
			title: $format('net_metering_period_60', { default: 'Hour' }),
		},
	];
};

export const isExperimentalNetMeteringEnabled = (): boolean => {
	return get(user_settings)?.experimental_features?.nm?.enabled === 1;
};

export const isSupportNetMetering = (device: Device) => {
	return isProAnyEM(device?.type) && isSupportFWNetMetering(device);
};

export const isSupportFWNetMetering = (device: Device) => {
	const settings = devices_settings.getByRealId(device?.id);
	const fwVersion = settings?.DeviceInfo?.ver || settings?.sys?.device?.fw_id || '0.0.1';
	return compareFWVersions(fwVersion, '>=', '1.5.0');
};

export const disableAllNetMetering = async () => {
	const allDevices: { [key: string]: Device } = get(devices);
	Object.entries(allDevices).forEach(async ([key, device]) => {
		if (isProAnyEM(device?.type) && device?.cloud_options?.measure_net_energy > 0) {
			const res = await postReq('interface/device/set_cloud_options', {
				id: key,
				set: 'measure_net_energy',
				val: 0,
			});
			if (res?.isok) {
				device.cloud_options.measure_net_energy = 0;
				devices.update(device);
			}
		}
	});
};
